export default "__VITE_ASSET__0d551713__"